import { user as actions } from '../actions'
import { mergeDeepRight, assoc, pathOr } from 'ramda'

// Reducers for
// store/action-methods/user.js
export const reducer = {}

reducer[actions.SET_USER] = ({ state, action }) => {
  return mergeDeepRight(state.user, action.user)
}

reducer[actions.UPDATE_USER] = ({ state, action }) => {
  return action.fn(state)
}

reducer[actions.DISMISS_NOTIFICATION] = ({ state, action }) => {
  const newNotifs = state.notifications.data.filter(x => {
    return x[':db/id'] != action.notificationId
  })

  const newUnreadData = pathOr(
    [],
    ['unreadNotifications', 'data'],
    state
  ).filter(x => {
    return x[':db/id'] != action.notificationId
  })

  return {
    notifications: assoc('data', newNotifs, state.notifications),
    unreadNotifications: assoc(
      'data',
      newUnreadData,
      state.unreadNotifications
    ),
    notificationsCount: state.notificationsCount - 1
  }
}

reducer[actions.DISMISS_ALL_NOTIFICATIONS] = ({ state, action }) => {
  return {
    notifications: { data: [] },
    unreadNotifications: { data: [] },
    acknowledgedNotifications: state.notifications,
    notificationsCount: 0,
    dismissingNotifications: false
  }
}

reducer[actions.SET_USER_NETWORKS] = ({
  state,
  action: { payload: newNetworks }
}) => ({
  ...state,
  networks: newNetworks
})

reducer[actions.ADD_USER_EMAIL] = ({
  state,
  action: { payload: newEmail }
}) => ({
  ...state,
  ':user/emails': [...state[':user/emails'], newEmail]
})

reducer[actions.REMOVE_USER_EMAIL] = ({
  state,
  action: {
    payload: { removedEmailId, newPrimaryEmailId }
  }
}) => ({
  ...state,
  ':user/emails': state[':user/emails'].filter(
    ({ ':db/id': id }) => id !== removedEmailId
  ),
  ':user/primary-email': newPrimaryEmailId
    ? state[':user/emails'].find(e => e[':db/id'] === newPrimaryEmailId)
    : state[':user/primary-email']
})

reducer[actions.SET_USER_PRIMARY_EMAIL] = ({
  state,
  action: { payload: emailId }
}) => ({
  ...state,
  ':user/primary-email': state[':user/emails'].find(
    e => e[':db/id'] === emailId
  )
})
